<h3>{{ title }}</h3>
<p>{{ description }}</p>
<button acorn-button color="primary" (click)="sendEmail()">Contact Us</button>
